// extracted by mini-css-extract-plugin
export default {"fifth":"WhoAreWe_fifth__CdcYj","text_container5":"WhoAreWe_text_container5__2i4cT","list":"WhoAreWe_list__zWHrS","separator":"WhoAreWe_separator__pYP64"};